import { Injectable } from '@angular/core';
import { DataEntryTreeDto } from '@osos/shared/api';
import { DataEntryTreePresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { DataEntryTreeParserV1Service } from '../../parsers/data-entry-tree-parser/data-entry-tree-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class DataEntryTreeFactoryService extends FactoryBase<
  DataEntryTreeDto,
  DataEntryTreePresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntryTreeParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: DataEntryTreePresenterModel): DataEntryTreeDto {
    throw new Error('Method not implemented.');
  }

  createPresenterModel(model: DataEntryTreeDto): DataEntryTreePresenterModel {
    const parser = this.getParser(
      DataEntryTreeDto,
      DataEntryTreePresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
